import { render, staticRenderFns } from "./NavBarLink.vue?vue&type=template&id=6cf3ca23&scoped=true"
import script from "./NavBarLink.vue?vue&type=script&lang=js"
export * from "./NavBarLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf3ca23",
  null
  
)

export default component.exports